import { Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function DiscoverHighlights({ originalCount }: { originalCount: number }) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(originalCount);

  useEffect(() => {
    fetch("/api/catalog?page=1&pageSize=1&sort=newest")
      .then((response) => response.ok ? response.json() as Promise<{ total: number }> : null)
      .then((body) => { if (body) setTotal(body.total); })
      .catch(() => undefined);
  }, []);

  const workshopCount = Math.max(0, total - originalCount);
  return <section className="discover-highlights">
    <div className="discover-hero">
      <div><span className="eyebrow"><Sparkles size={13}/> {t("discover.eyebrow")}</span><h2>{t("discover.title")}</h2><p>{t("discover.description")}</p></div>
      <div className="discover-stats"><div><strong>{total}</strong><span>{t("discover.available")}</span></div><div><strong>{originalCount}</strong><span>{t("discover.originals")}</span></div><div><strong>{workshopCount}</strong><span>{t("discover.workshop")}</span></div></div>
    </div>
  </section>;
}
